import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { AdminManagerService } from "../../admin/services/admin-manager.service";
import { Observable } from "rxjs";
import { Router } from "@angular/router";
import { getParameterByName } from "@devwareapps/devware-cap";
import { tap } from "rxjs/operators";
import { IntegrationHeaders } from "../models/integration-headers.enum";
import { IntegrationUtilService } from "../services/integration-util.service";

@Injectable()
export class IntegrationDataHttpInterceptor implements HttpInterceptor {

    private _integrationUtilService : IntegrationUtilService;
    
    get integrationUtilService() : IntegrationUtilService {
        if (this._integrationUtilService == null) {
            this._integrationUtilService = this.injector.get(IntegrationUtilService);
        }

        return this._integrationUtilService;
    }

    constructor(private injector: Injector) {

    }

    AVIATOR_USER_INTEGRATION_RESPONSE = "AVIATOR_USER_INTEGRATION_RESPONSE";
    AVIATOR_SCHOOL_INTEGRATION_RESPONSE = "AVIATOR_SCHOOL_INTEGRATION_RESPONSE";

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const headers: { [prop:string]: string } = {};

        if (request.method === 'POST' && request.url.split('?')[0].endsWith('/security/authentication/user')) {
            headers['AVIATOR-DEFER-CHECKOUT-RECOVERY'] = 'true';
        }

        // Check if there is a type and token so we can pass it to the client
        const type = this.integrationUtilService.getIntegrationTokenTypeParam();
        const token = this.integrationUtilService.getIntegrationTokenParam();
        
        if (type && token) {
            headers[IntegrationHeaders.AVIATOR_INTEGRATION_TYPE] = type;
            headers[IntegrationHeaders.AVIATOR_INTEGRATION_TOKEN] = token;
        }

        const stripeSessionToken = this.integrationUtilService.getStripeToken();

        if (stripeSessionToken) {
            headers[IntegrationHeaders.AVIATOR_STRIPE_SESSION_TOKEN] = stripeSessionToken;
        }

        const schoolSignupToken = this.integrationUtilService.getSchoolSignupTokenParam();

        if (schoolSignupToken) {
            headers[IntegrationHeaders.AVIATOR_SCHOOL_SIGNUP_TOKEN] = schoolSignupToken;
        }

        request = request.clone({
            headers: request.headers,
            setHeaders : headers
        })

        return next.handle(request) 
        .pipe(tap(event => {
            try {
                if (event instanceof HttpResponse) {
                    const eventResponse = event as HttpResponse<any>;
                    const userIntegrationResponse = eventResponse.headers.get(this.AVIATOR_USER_INTEGRATION_RESPONSE);
                    const schoolIntegrationResponse = eventResponse.headers.get(this.AVIATOR_SCHOOL_INTEGRATION_RESPONSE);
    
                    if (userIntegrationResponse) {
                        this.integrationUtilService.handleUserIntegrationResponse(userIntegrationResponse);
                    }
                    if (schoolIntegrationResponse) {
                        this.integrationUtilService.handleSchoolIntegrationResponse(schoolIntegrationResponse);
                    }
                }
            } catch(e) {
                console.warn("Error in IntegrationDataHttpInterceptor", e);
            }
        }));
    }
}
